<template>
  <div class="mim-msg mim-common-seciton">
    <el-dialog
      title="构件信息"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal="false"
      :visible.sync="open"
    >
      <template v-if="!msg && !parentNode">
        <div class="not-leaf"><i class="el-icon-warning"></i> 暂无属性</div>
      </template>
      <template v-else-if="!msg && parentNode">
        <div class="not-leaf">
          <i class="el-icon-warning"></i> 请选择一个构件，以查看对应属性
        </div>
      </template>
      <template v-else-if="msg && parentNode">
        <table class="bf-table box-card bf-panel-container bf-scroll-bar">
          <template>
            <tbody class="bf-group">
              <template v-for="(orderKey, index) in GroupOrder">
                <tr :key="index" class="bf-group-title">
                  <td colspan="2">{{ curAttribute[orderKey].GroupName }}</td>
                </tr>
                <tr
                  class="bf-group-content"
                  v-for="(item, index) in getAtrributeKeys(
                    curAttribute[orderKey].AttriOrder
                  )"
                  :key="`${orderKey}_${index}`"
                >
                  <td class="bf-key">{{ allKeys[item] }}</td>
                  <td class="bf-value">
                    <template v-if="item == 'ProClassId'">
                      {{ parentNode.Name || "" }}
                    </template>
                    <template v-else> {{ msg[item] }}</template>
                  </td>
                </tr>
              </template>
            </tbody>
          </template>
        </table></template
      >
    </el-dialog>
  </div>
</template>

<script>
const comKeys = {
  Name: "工程类别",
  ModelName: "工程名称",
  SecName: "断面类型",
  SecStyle: "拱形",
  SteelRail: "轨道",
  SecDim: "断面尺寸(m)",
  Area_NetSec: "净断面积(㎡)",
  Area_DigSec: "掘进面积(㎡)",
  SupportType: "支护类型",
  ThickSide: "支护厚度",
  ThickBottom: "底部支护厚度",
  Volume_DigSec: "掘进量(m³)",
  Volume_Support: "支护量(m³)",
  Mess_Steel: "钢材量(t)",
  WYCSWD: "围岩初始温度",
  JFWD: "进风温度",
  FLLS: "风流流速",
  YSRDL: "岩石热导率",
  YSBR: "岩石比热",
  YSMD: "岩石密度γ",
  KJTFSJ: "矿井通风时间",
  TFZLXS: "通风阻力系数",
  TFZAWMJ: "障碍物面积",
  ProClassId: "工程类别",
};
export default {
  data() {
    return {
      open: false,
      msg: {},
      parentNode: {},
    };
  },
  props: {
    msgValue: {
      type: Object,
      default: () => {},
    },
  },
  components: {},
  computed: {
    EntityType() {
      return this.msg.EntityType || {};
    },
    treeList() {
      return this.msgValue.categoryTree || [];
    },
    // 巷道
    Type1() {
      return this.EntityType == 1;
    },
    // 井筒长度
    Type2() {
      return this.EntityType == 2;
    },
    // 井筒长度
    Type3() {
      return this.EntityType == 3;
    },
    allKeys() {
      return this.Type1
        ? { ...comKeys, Length: "巷道长度" }
        : this.Type2
        ? { ...comKeys, Length: "井筒长度" }
        : comKeys;
    },
    attributeKey() {
      return this.Type1
        ? "AttriGroup_Tunnel"
        : this.Type2
        ? "AttriGroup_Well"
        : "AttriGroup_Chamber";
    },
    curAttribute() {
      return this.msgValue[this.attributeKey];
    },
    GroupOrder() {
      return this.curAttribute ? this.curAttribute.GroupOrder.split("|") : [];
    },
  },
  methods: {
    handleOpen(parentNode, obj) {
      console.log("查看详情parentNode, obj", parentNode, obj);
      this.parentNode = parentNode;
      if (!this.open) {
        this.open = true;
      }
      this.msg = obj;
    },
    getAtrributeKeys(obj) {
      return obj ? obj.split("|") : [];
    },
  },
  created() {},
  mounted() {},
  watch: {},
};
</script>

<style>
@import "./tree.css";
.mim-msg.mim-common-seciton .el-dialog__wrapper {
  top: 10px !important;
  right: 0px;
  left: inherit;
}
/* .mim-msg.mim-common-seciton .box-card {
  height: 400px;
  overflow: auto;
} */
.bf-table {
  width: 100%;
  border-collapse: collapse;
}
.mim-msg.mim-common-seciton .bf-table .bf-group-title {
  background-color: rgba(85, 85, 85, 0.45);
}
.mim-msg.mim-common-seciton .bf-table .bf-key {
  color: #999;
  padding-left: 26px;
  width: 40%;
}
.mim-msg.mim-common-seciton .bf-table td {
  vertical-align: middle;
  line-height: 20px;
  padding: 5px;
  border: 1px solid #3f3f3f;
  word-break: break-all;
}
.mim-msg.mim-common-seciton .el-dialog__wrapper .not-leaf {
  font-size: 12px;
  margin-top: 36px;
  text-align: center;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/mim/msg.vue